// 动态导入 Blockly，避免在页面加载时立即加载 21.8MB 的文件
export default defineNuxtPlugin((_nuxtApp) => {
  // 缓存加载的模块，避免重复加载
  let blocklyStateLoader: any = null
  let loadingPromise: Promise<any> | null = null

  /**
   * 懒加载 Blockly 模块
   * 只在需要时才加载 21.8MB 的 Blockly 文件
   * @returns Promise<loadBlocklyState function>
   */
  const loadBlockly = () => {
    // 如果已经加载，直接返回
    if (blocklyStateLoader) {
      return Promise.resolve(blocklyStateLoader)
    }

    // 如果正在加载，返回现有的 Promise
    if (loadingPromise) {
      return loadingPromise
    }

    // 开始动态加载
    loadingPromise = Promise.all([
      // @ts-ignore - Blockly 是 JS 文件，没有类型定义
      import('@/utils/blockly/fe-blockly-web'),
      import('@/utils/blockly/style.css')
    ])
      .then(([blocklyModule]: [any, any]) => {
        blocklyStateLoader = blocklyModule.loadBlocklyState
        return blocklyStateLoader
      })
      .catch((error) => {
        console.error('Failed to load Blockly:', error)
        loadingPromise = null // 失败后重置，允许重试
        throw error
      })

    return loadingPromise
  }

  return {
    provide: {
      blockly: loadBlockly
    }
  }
})
